module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921104151_T.45a0b12f.jpg";